export default __webpack_public_path__ + "static/media/apple.b6187a92.png";